export const updatesList = [
  {
    id: "v5-0",
    version: "5.0",
    title: "「璃月远征」版本更新",
    date: "2026-10-11",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20epic%20mountain%20landscape%20with%20floating%20islands%20and%20ancient%20city%20gates%2C%20cool%20teal%20and%20gold%20color%20palette%2C%20grand%20adventure%20concept%20art%2C%20painterly%20fantasy%20style&width=1200&height=600&seq=update-cover-50&orientation=landscape",
    intro: "本次大版本带来全新地区「云上璃月」、两名五星角色、全新剧情章节与元素共鸣系统调整。",
    sections: [
      {
        heading: "全新地区「云上璃月」",
        items: [
          "开放全新地图区域，包含三座浮空岛屿与五个传送锚点。",
          "新增地区探索度奖励与原产地特产品种。",
          "新增地区世界任务与隐藏成就共计 24 项。",
        ],
      },
      {
        heading: "新角色登场",
        items: [
          "五星水元素单手剑角色「雾泽」，定位为主输出。",
          "五星风元素弓角色「岚心」，定位为辅助核心。",
          "四星火元素单手剑角色「熔铸」，可通过活动获得。",
        ],
      },
      {
        heading: "系统与平衡性调整",
        items: [
          "元素共鸣数值重新平衡，双属性共鸣效果整体提升。",
          "优化深境螺旋的层间加载速度。",
          "调整部分圣遗物套装的效果描述，实际效果不变。",
        ],
      },
      {
        heading: "活动与福利",
        items: [
          "「璃月远征」版本预热活动同步开启。",
          "登录即可领取版本更新补偿原石 ×300。",
          "新增版本纪念名片与限定喷漆。",
        ],
      },
    ],
    history: ["v4-8", "v4-7", "v4-6"],
  },
  {
    id: "v4-8",
    version: "4.8",
    title: "「盛夏海滨」版本更新",
    date: "2026-08-20",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20sunny%20seaside%20resort%20with%20turquoise%20water%20and%20white%20cliffs%2C%20bright%20summer%20tones%2C%20relaxed%20fantasy%20landscape%2C%20painterly%20style&width=1200&height=600&seq=update-cover-48&orientation=landscape",
    intro: "夏日海滨版本开放全新水上玩法，新增海滨主题任务与限定泳装装扮。",
    sections: [
      {
        heading: "全新水上玩法",
        items: [
          "新增冲浪与潜水小游戏，可获得限定代币。",
          "开放海滨度假区域与专属剧情。",
        ],
      },
      {
        heading: "角色与装扮",
        items: [
          "新增五星角色「霜花序」及配套武器池。",
          "上架海滨主题限定装扮。",
        ],
      },
    ],
    history: ["v4-7", "v4-6", "v4-5"],
  },
  {
    id: "v4-7",
    version: "4.7",
    title: "「古城回响」版本更新",
    date: "2026-06-30",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20ancient%20desert%20city%20ruins%20at%20dusk%20with%20warm%20torchlight%2C%20orange%20and%20ochre%20tones%2C%20mysterious%20ruins%20concept%20art%2C%20painterly%20fantasy%20style&width=1200&height=600&seq=update-cover-47&orientation=landscape",
    intro: "古城回响版本带来自走棋式的塔防玩法，以及多名角色的平衡性调整。",
    sections: [
      {
        heading: "全新玩法「遗址守卫」",
        items: [
          "玩家需布置角色防御设施抵御敌人波次。",
          "完成关卡可获得专属称号与素材奖励。",
        ],
      },
      {
        heading: "平衡性调整",
        items: [
          "提升部分四星角色的基础倍率。",
          "修复了元素充能效率显示异常的问题。",
        ],
      },
    ],
    history: ["v4-6", "v4-5", "v4-4"],
  },
  {
    id: "v4-6",
    version: "4.6",
    title: "「雷鸣之约」版本更新",
    date: "2026-05-18",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20stormy%20mountain%20peak%20with%20lightning%20strikes%20and%20stone%20shrine%2C%20deep%20violet%20and%20blue%20tones%2C%20dramatic%20fantasy%20landscape%2C%20painterly%20style&width=1200&height=600&seq=update-cover-46&orientation=landscape",
    intro: "雷鸣之约版本上线新雷元素角色，并对深境螺旋环境进行了整体切换。",
    sections: [
      {
        heading: "新角色「雷鸣」",
        items: [
          "五星雷元素长柄武器角色，定位为主输出。",
          "专属武器「薙草之稻光」同步进入限定卡池。",
        ],
      },
      {
        heading: "深渊环境更新",
        items: [
          "第十二层敌人配置调整，新增两名精英。",
          "深渊祝福改为元素爆发增伤。",
        ],
      },
    ],
    history: ["v4-5", "v4-4", "v4-3"],
  },
  {
    id: "v4-5",
    version: "4.5",
    title: "「花神诞祭」版本更新",
    date: "2026-04-12",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20blooming%20flower%20fields%20with%20floating%20petals%20and%20distant%20temple%2C%20soft%20pink%20and%20green%20tones%2C%20festive%20fantasy%20landscape%2C%20painterly%20style&width=1200&height=600&seq=update-cover-45&orientation=landscape",
    intro: "花神诞祭版本以须弥花神节为主题，带来丰富的节日玩法与限定奖励。",
    sections: [
      {
        heading: "节日玩法",
        items: [
          "开放花车巡游与花艺小游戏。",
          "节日商店限时兑换限定摆设。",
        ],
      },
      {
        heading: "新角色与活动",
        items: [
          "新增四星水元素法器角色「蒹葭」。",
          "登录活动累计可领取原石 ×600。",
        ],
      },
    ],
    history: ["v4-4", "v4-3", "v4-2"],
  },
];